export enum API_ROUTES {
  LOGIN = "/account/signin",
  REFRESH_TOKEN = "/account/refresh",
  VERIFY_RESET = "/account/verify-reset",
  RESET_PASSWORD = "/account/reset-password",
  GET_USER = "/account/get",
  GET_USER_BALANCE = "/account/balance",
  GET_ASSET_EVOLUTION = "/account/asset-evolution",
  GET_PRODUCT_LIST = "/account/schemes",
  GET_PRODUCT = "/account/scheme",
  GET_ASSET_PERFORMANCE_EVOLUTION = "/account/performance-evolution",
  GET_SCHEME_CAPITAL = "/account/scheme-capital-and-unrealised",
  GET_PENDING_TRANSACTIONS = "/account/pending-transactions",
  GET_TRANSACTIONS_HISTORY = "/account/transaction-history",
  GET_ASSOCIATED_ACCOUNTS = "/account/family/balance",
  GET_CUSTOMER = "/account/get_customer",
}